import type { Template } from "@/types";

export const PO_03_H3_V0: Template[] = [
    {
        id: "po-03-h3v0-01",
        name: "PO 01 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 61, y: 322, width: 412, height: 274, rotation: 0, imageRotation: 0 },
            { id: "2", x: 481, y: 322, width: 412, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 901, y: 322, width: 412, height: 274, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-02",
        name: "PO 02 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 307, width: 453, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 461, y: 307, width: 453, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 922, y: 307, width: 452, height: 301, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-03",
        name: "PO 03 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 71, y: 91, width: 545, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 462, width: 545, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 757, y: 277, width: 545, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-04",
        name: "PO 04 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 71, y: 91, width: 545, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 462, width: 545, height: 362, rotation: 0, imageRotation: 0 },
            { id: "3", x: 687, y: 231, width: 687, height: 453, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-03-h3v0-05",
        name: "PO 05 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 112, y: 182, width: 378, height: 272, rotation: 0, imageRotation: 0 },
            { id: "2", x: 112, y: 462, width: 378, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 498, y: 182, width: 764, height: 552, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-03-h3v0-06",
        name: "PO 06 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 305, y: 104, width: 764, height: 439, rotation: 0, imageRotation: 0 },
            { id: "2", x: 305, y: 551, width: 378, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 551, width: 378, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-07",
        name: "PO 07 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [           
            { id: "1", x: 0, y: 129, width: 407, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 461, width: 407, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 415, y: 129, width: 959, height: 657, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-08",
        name: "PO 08 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 64, y: 160, width: 368, height: 294, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 462, width: 368, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 440, y: 160, width: 870, height: 596, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-03-h3v0-09",
        name: "PO 09 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 125, y: 199, width: 790, height: 518, rotation: 0, imageRotation: 0 },
            { id: "2", x: 923, y: 199, width: 327, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 923, y: 462, width: 327, height: 255, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h3v0-10",
        name: "PO 10 - H3V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h3_v0_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 72, y: 277, width: 545, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 758, y: 91, width: 545, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 758, y: 462, width: 545, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

];

